import { createFileRoute } from "@tanstack/react-router";

import AgentProposals from "../pages/AgentProposals";
import { RequireAuth } from "../utils/RequireAuth";

export const Route = createFileRoute("/_shell/agent-proposals")({
  component: AgentProposalsRoute,
});

function AgentProposalsRoute() {
  return (
    <RequireAuth require="admin">
      <AgentProposals />
    </RequireAuth>
  );
}
